import React from 'react';

import ThemeIcon from '@atlaskit/icon/core/theme';

export const ThemesIcon = () => <ThemeIcon label="" spacing="spacious" />;
